export const getters = {
  isAuthenticated: (state) => !!state.token,
  
};
